import { api } from '@/api/client';
import type { Customer, Supplier } from './types';
export function savePartner(kind: 'customer' | 'supplier', id: string | undefined, payload: Record<string, unknown>) {
  const path = `/api/v2/${kind === 'customer' ? 'customers' : 'suppliers'}`;
  return id ? api.patch<Customer | Supplier>(`${path}/${encodeURIComponent(id)}`, payload) : api.post<Customer | Supplier>(path, payload);
}
export function deleteCustomer(id: string) { return api.delete(`/api/v2/customers/${encodeURIComponent(id)}`); }

export function deleteCustomers(ids: string[]) { return api.post('/api/v2/customers/batch-delete', { ids }); }
